export default __webpack_public_path__ + "static/media/india2019A.6c3860c7.jpg";